import { Button } from '@analytical-alley/ui';

export const Footer = ({ isDirty, isRunning, canRun, onClick }: { isDirty: boolean; isRunning: boolean; canRun: boolean; onClick: () => void }) => (
    <div className="flex justify-center gap-4 items-center px-6 py-4 ">
        <Button
            color={isDirty ? 'blue' : 'glass'}
            size="lg"
            onClick={onClick}
            disabled={!canRun}
            tooltip={isDirty ? 'Find the best channel budgets according to the values you set.' : 'Everything is up to date'}
        >
            {isRunning ? 'Optimizing...' : isDirty ? 'Run Optimization' : 'Already Optimized'}
        </Button>
    </div>
);
